import { useMutation } from 'react-query'
import { postPaypalOrder } from '../api'

const useCreatePaypalOrder = () => {
    const { mutateAsync } = useMutation(postPaypalOrder)
    return { mutateAsync }
}

export default useCreatePaypalOrder
